<template>
  <v-row>
    <v-col>
      <v-btn
        color="success"
        align-center
        @click="formOn"
        v-if="!user.roles.includes('CONSULTATION')"
      >
        Créer un lot
      </v-btn>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-table
        :headers="headers"
        :items="lots"
        :expanded.sync="lotExpand"
        :show-expand="showDemandes"
        :single-expand="true"
        class="elevation-1"
        pagination.sync="pagination"
        loading="true"
        v-if="lots.length != 0"
        sort-by="id"
        :sort-desc="true"
      >
        <template v-slot:[`item.libelle`]="{ item }">
          <v-edit-dialog
            ref="edit"
            aareturn-value.sync="item.libelle"
            @save="save(item)"
            v-if="item.exportPaie == 0 && !consultation"
          >
            {{ item.libelle }}
            <template v-slot:input>
              <v-text-field
                v-model="item.libelle"
                label="Modifier"
                counter
                :disabled="item.cloture !== null && item.cloture !== ''"
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>{{ item.libelle }}</div>
        </template>
        <template v-slot:[`item.cloture`]="{ item }">
          {{
            item.cloture
              ? new Date(item.cloture).toLocaleString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}
        </template>
        <template v-slot:[`item.etatCloture`]="{ item }">
          {{ item.etatCloture == false ? "Ouvert" : "Fermé" }}
        </template>
        <template v-slot:[`item.exportPaie`]="{ item }">
          {{ item.exportPaie == false ? "Non Transmis" : "Transmis" }}
        </template>
        <template v-slot:[`item.anneePaiement`]="{ item }">
          <v-edit-dialog
            ref="editAnnee"
            @save="save(item)"
            v-if="item.exportPaie == 0 && !consultation"
          >
            {{ item.anneePaiement }}
            <template v-slot:input>
              <v-text-field
                v-model="item.anneePaiement"
                label="Modifier"
                counter
                :rules="[
                  (value) =>
                    (!!value && /^20[0-9]{2,2}$/.test(value)) ||
                    'Veuillez rentrer une année.',
                ]"
                :disabled="item.cloture !== null && item.cloture !== ''"
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>{{ item.anneePaiement }}</div>
          <div
            v-if="!/^20[0-9]{2,2}$/.test(item.anneePaiement)"
            class="red--text font-weight-bold"
          >
            L'année n'a pas été sauvegardée
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="!consultation">
            <v-btn
              color="warning"
              v-if="!item.etatCloture && !item.exportPaie"
              outlined
              rounded
              @click="cloturer(item)"
              :disabled="item.nbrDemandes < 1"
              >Cloturer</v-btn
            >
            <v-btn
              color="success"
              v-if="item.etatCloture && !item.exportPaie"
              outlined
              rounded
              @click="reouvrir(item)"
              >Réouvrir</v-btn
            >&nbsp;<v-btn
              color="success"
              v-if="item.exportPaie"
              outlined
              rounded
              :disabled="true"
              >Exporté</v-btn
            >
            <v-btn
              color="error"
              fab
              small
              icon
              @click="supprimer(item)"
              v-if="item.nbrDemandes < 1 && item.exportPaie == 0"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </div>
        </template>
        <template v-slot:[`item.uid_gestionnaire`]="{ item }">
          <div v-if="DRHs">{{ filterGestionnaire(item) }}</div>
        </template>
        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" v-if="demandesParLot.length > 0">
            <v-data-table
              :headers="headersDemandes"
              :items="demandesParLot"
              class="blue lighten-4"
            >
              <template v-slot:[`header.nomPrenom`]="{ header }">
                {{ header.text }}
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon slot="activator" v-bind="attrs" v-on="on">
                      <v-icon small :color="filterNomPrenom ? 'info' : ''"
                        >mdi-filter</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-card class="block">
                    <v-text-field
                      v-model="filterNomPrenom"
                      label="entrer un élément de recherche"
                    >
                    </v-text-field>
                    <v-btn
                      color="error"
                      small
                      text
                      @click="filterNomPrenom = null"
                      >Annuler
                    </v-btn>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:[`item.typeSouscription`]="{ item }">
                <v-col>{{
                  refTypeSouscription[item.typeSouscription - 1].name
                }}</v-col>
              </template>
              <template v-slot:[`item.debutContrat`]="{ item }">
                <v-col>{{
                  item.debutContrat
                    ? new Date(item.debutContrat).toLocaleString("fr-FR", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : ""
                }}</v-col>
              </template>
              <template v-slot:[`item.cotisationParEmployeur`]="{ item }">
                <v-col v-if="item.cotisationParEmployeur == true">Oui</v-col>
                <v-col v-else-if="item.cotisationParEmployeur == false"
                  >Non</v-col
                >
              </template>
              <template v-slot:[`item.etat`]="{ item }">
                <div class="font-weigth-bold">
                  <v-chip color="grey">{{ item.etat }}</v-chip>
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <!-- tooltip pour l'affichage du message d'annulation, le bouton sert à ne pas afficher systèmatique le span en passant dessus -->
                <v-tooltip
                  bottom
                  color="red"
                  max-width="150px"
                  v-if="item.etat == 'ANNULATION'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs">
                      <v-btn icon :disabled="true">
                        <v-icon>settings_backup_restore</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ affichageAnnulation(item) }}</span>
                </v-tooltip>
                <v-btn
                  v-else
                  icon
                  @click="dialogAnnulation(item)"
                  color="error"
                  :disabled="!lotExport || item.etat == 'ANNULATION'"
                >
                  <v-icon>settings_backup_restore</v-icon></v-btn
                >
              </template>
              <template v-slot:[`item.nameFile`]="{ item }">
                <v-btn
                  v-if="item.nameFile != null"
                  icon
                  @click="afficherPDF(item)"
                  ><v-icon color="green">mdi-book-open-variant</v-icon></v-btn
                >
              </template>
            </v-data-table>
            <v-btn
              color="success"
              :href="exportLot"
              target="_blank"
              v-if="lotExport"
            >
              <v-icon>mdi-export</v-icon> Export Lot
            </v-btn>
          </td>
          <div class="text-center" v-else>
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <BaseBlock title="Création du Lot">
        <v-form v-model="formCreation" ref="formCreation" lazy-validation>
          <v-text-field
            v-model="lot.anneePaiement"
            name="Année de Paiement"
            label="Année de paiement"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (value) =>
                (!!value && /^20[0-9]{2,2}$/.test(value)) ||
                'Veuillez rentrer une année.',
            ]"
            required
          ></v-text-field>
          <v-text-field
            v-model="lot.libelle"
            name="Intitulé"
            label="Intitulé"
            :rules="[(value) => !!value || 'Champ requis.']"
            required
          ></v-text-field>
          <v-select
            v-if="DRHs"
            :items="DRHs"
            label="Choix du gestionaire"
            item-text="nomPrenomGestionnaire"
            v-model="lot.uid_gestionnaire"
            item-value="gestionnaire"
            single-line
            clearable
            required
            :rules="[(value) => !!value || 'Champ requis.']"
          ></v-select>
          <div class="text-center">
            <v-btn color="success" :disabled="!formCreation" @click="saveLot"
              ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
            >&nbsp;
            <v-btn color="warning" @click="annuler"
              ><v-icon left>mdi-refresh</v-icon>Effacer</v-btn
            >&nbsp;
            <v-btn color="info" @click="formOff"
              ><v-icon>mdi-close</v-icon>Fermer</v-btn
            >
          </div>
        </v-form>
      </BaseBlock>
    </v-dialog>

    <v-dialog v-model="dialogPDF" max="100%" @click:outside="iframeSrc = null">
      <BaseBlock>
        <v-responsive height="500px"
          ><iframe
            height="100%"
            width="100%"
            :src="iframeSrc"
            title="document PDF"
          ></iframe></v-responsive
        ><br />
        <div class="text-center">
          <v-btn
            color="info"
            @click="
              iframeSrc = null;
              dialogPDF = false;
            "
            >fermer</v-btn
          >
        </div>
      </BaseBlock>
    </v-dialog>

    <v-dialog v-model="dialogAnnule" persistent max-width="500px">
      <BaseBlock>
        <v-form ref="formAnnulation" v-model="formAnnulation" lazy-validation>
          <v-textarea
            label="Motif de l'annulation"
            v-model="messageAnnulation"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (v) =>
                (v || '').length <= 4000 ||
                `le nombre de caractères doit être inférieur à 4000.`,
            ]"
            required
            auto-grow
            counter="4000"
          ></v-textarea>
          <v-btn
            color="success"
            @click="annulationDemande"
            :disabled="!formAnnulation"
            >Valider</v-btn
          >
          <v-btn color="info" @click="fermerDialogAnnulation">Fermer</v-btn>
        </v-form>
      </BaseBlock>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiFormComplementaireRepository from "@/repositories/ApiFormComplementaireRepository";
import ApiFormComplementaireLotRepository from "@/repositories/ApiFormComplementaireLotRepository";
import ApiGestionnaireRepository from "@/repositories/ApiGestionnaireRepository";
import { mapState } from "vuex";

export default {
  name: "AdministrationDesLots",
  components: { BaseBlock },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          value: "data-table-expand",
        },
        {
          text: "Code",
          align: "start",
          value: "id",
        },
        { text: "Etat", value: "etatCloture" },
        { text: "Date de clôture", value: "cloture" },
        { text: "Intitulé", value: "libelle" },
        { text: "Etat Winpaie", value: "exportPaie" },
        { text: "Année paiement", value: "anneePaiement" },
        { text: "Gestionnaire", value: "uid_gestionnaire" },
        { text: "Nbr dossiers", value: "nbrDemandes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersDemandes: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Demandeur",
          value: "nomPrenom",
          align: "start",
        },
        {
          text: "Nom de la complémentaire Santé",
          value: "nomComplementaire",
          align: "start",
        },
        { text: "Type de souscription", value: "typeSouscription" },
        {
          text: "Cotisation par l'employeur ?",
          value: "cotisationParEmployeur",
        },
        { text: "Date d'effet", value: "debutContrat", dateType: "Date" },
        { text: "Etat", value: "etat" },
        { text: "Action", value: "actions" },
        { text: "Fichier joint", value: "nameFile" },
      ],
      lots: [],
      lot: {
        id: null,
        libelle: null,
        uid_gestionnaire: null,
        anneePaiement: null,
        etatCloture: null,
        cloture: null,
        exportPaie: null,
        nbrDemandes: null,
      },
      lotExpand: [],
      formCreation: true,
      DRHs: [],
      demandesParLot: [],
      showDemandes: false,
      consultation: false,
      filterNomPrenom: null,
      refTypeSouscription: null,
      dialogPDF: false,
      iframeSrc: null,
      lotExport: false,
      formComplementaire: {},
      dialogAnnule: false,
      formAnnulation: false,
      messageAnnulation: null,
      exportLot: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    filteredDemandes() {
      var conditions = [];

      if (this.filterNomPrenom) {
        conditions.push(this.filtrageNomPrenom);
      }

      if (conditions.length > 0) {
        return this.demandesParLot.filter((demande) => {
          return conditions.every((condition) => {
            return condition(demande);
          });
        });
      }
      return this.demandesParLot;
    },
  },
  watch: {
    lotExpand: function () {
      this.getDemandesParLot();
    },
  },
  async created() {
    this.lots = await ApiFormComplementaireLotRepository.getLots();
    if (this.user.roles.includes("CONSULTATION")) {
      this.consultation = true;
    } else {
      this.DRHs = await ApiGestionnaireRepository.getGestionnaires();
    }
    this.refTypeSouscription =
      await ApiFormComplementaireRepository.getRefTypeSouscriptions();
    this.showDemandes = true;
  },
  methods: {
    async save(item) {
      await ApiFormComplementaireLotRepository.updateLot(
        this.lots[this.lots.indexOf(item)]
      );
    },
    formOn() {
      this.dialog = true;
    },
    formOff() {
      this.dialog = false;
      this.annuler();
    },
    async saveLot() {
      if (this.$refs.formCreation.validate()) {
        this.lots.push(
          await ApiFormComplementaireLotRepository.saveLot(this.lot)
        );

        this.formOff();
      }
    },
    annuler() {
      this.$refs.formCreation.reset();
      this.lot = Object.assign({});
    },
    async cloturer(item) {
      this.lots[this.lots.indexOf(item)].etatCloture = true;
      this.lot = await ApiFormComplementaireLotRepository.updateLot(
        this.lots[this.lots.indexOf(item)]
      );
      Object.assign(this.lots[this.lots.indexOf(item)], this.lot);
      this.lot = Object.assign({});
    },
    async reouvrir(item) {
      this.lots[this.lots.indexOf(item)].etatCloture = false;
      this.lot = await ApiFormComplementaireLotRepository.updateLot(
        this.lots[this.lots.indexOf(item)]
      );

      Object.assign(this.lots[this.lots.indexOf(item)], this.lot);
      this.lot = Object.assign({});
    },
    filterGestionnaire(item) {
      const a = this.DRHs.filter(function (el) {
        return el.gestionnaire == item.uid_gestionnaire;
      }).map((e) => e.nomPrenomGestionnaire);
      return a[0];
    },
    async supprimer(item) {
      await ApiFormComplementaireLotRepository.deleteById(item.id);
      this.$toast.info("le lot numéro " + item.id + " a été supprimé.");
      this.lots = this.lots.filter((element) => element != item);
    },
    async afficherPDF(item) {
      this.iframeSrc = await ApiFormComplementaireRepository.getDemandeFileDRH(
        item.id
      );

      this.dialogPDF = true;
    },
    async getDemandesParLot() {
      this.demandesParLot = [];
      this.exportLot = null;

      this.demandesParLot = await ApiFormComplementaireRepository.getByLot(
        this.lotExpand[0].id
      );
      if (this.lotExpand[0].exportPaie) {
        this.lotExport = true;
      } else {
        this.lotExport = false;
      }
      if (this.lotExport) {
        this.exportLot = ApiFormComplementaireLotRepository.exportLot(
          this.lotExpand[0].id
        );
      }
    },
    affichageAnnulation(item) {
      console.log(item);
      if (item.etat == "ANNULATION") {
        return item.messageAnnulation;
      }
    },
    async dialogAnnulation(item) {
      this.formComplementaire = item;
      this.dialogAnnule = true;
    },
    fermerDialogAnnulation() {
      this.dialogAnnule = false;
      Object.assign(this.formComplementaire, {});
      this.$refs.formAnnulation.reset();
    },
    async annulationDemande() {
      if (this.$refs.formAnnulation.validate()) {
        this.$confirm("Voulez-vous vraiment annuler la demande ?").then(
          async (reponse) => {
            if (reponse) {
              this.formComplementaire.etat = "ANNULATION";
              this.formComplementaire.messageAnnulation =
                this.messageAnnulation;
              await ApiFormComplementaireRepository.updateDemande(
                this.formComplementaire
              );
              this.fermerDialogAnnulation();
            }
          }
        );
      }
    },
  },
};
</script>
